import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgToastTranslocoService } from 'src/app/common/services/ng-toast-transloco/ng-toast-transloco.service';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { LoaderService } from 'src/app/common/services/loader/loader.service';

@Component({
  selector: 'ds-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrl: './email-confirmation.component.scss'
})
export class EmailConfirmationComponent implements OnInit, AfterViewInit {

  @Output() goToSignin = new EventEmitter();
  @Output() emailConfirmed = new EventEmitter<{ email: string; password: string; accountNumber: string }>();
  @Output() logout = new EventEmitter();

  @Input() emailAddress: string = '';

  emailConfirmationForm: FormGroup;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private toast: NgToastTranslocoService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  initForm() {
    this.emailConfirmationForm = this.fb.group({
      email: ['', [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/)
      ]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+=\-{}[\]:;"'<>,.?\/\\|`~])[A-Za-z\d@$!%*?&#^()_+=\-{}[\]:;"'<>,.?\/\\|`~]+$/)
      ]],
      confirmPassword: ['', [
        Validators.required
      ]]
    }, {
      validators: this.passwordMatchValidator
    });
  }

  passwordMatchValidator(group: FormGroup): { [key: string]: boolean } | null {
    const password = group.get('password');
    const confirmPassword = group.get('confirmPassword');
    
    if (!password || !confirmPassword) {
      return null;
    }
    
    return password.value === confirmPassword.value ? null : { passwordMismatch: true };
  }

  get email() {
    return this.emailConfirmationForm.get('email');
  }

  get password() {
    return this.emailConfirmationForm.get('password');
  }

  get confirmPassword() {
    return this.emailConfirmationForm.get('confirmPassword');
  }

  async continue() {
    if (!this.emailConfirmationForm.valid) {
      this.emailConfirmationForm.markAllAsTouched();
      this.cdr.detectChanges();
      return;
    }

    const email = this.email?.value;
    const password = this.password?.value;
    if (email && password) {
      const accountNumber = localStorage.getItem('acc_number') || '';
      this.emailConfirmed.emit({ email, password, accountNumber });
    }
  }

  goBack() {
    this.goToSignin.emit();
  }
}
